(() => {
  const PRODUCT_SELECTOR = '[data-product-sku]';
  const BASE_URL = 'https://minio-silverrepublic.3node-services.cz/arete/silverrepublic/silverrepublic_foto/RotaceSilver';

  const addGlobalEventListeners = (callback, signal) => {
    const options = signal ? { signal } : undefined;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, options);
    } else {
      callback();
    }

    document.addEventListener('pagination:page-changed', callback, options);
    document.addEventListener('facet:render', callback, options);
    document.addEventListener('product-recommendations:loaded', callback, options);
    document.addEventListener('line-item:change:end', callback, options);
  };

  const getTrimmedSku = (sku) => sku.trim().slice(0, -2);

  const build360Url = (trimmedSku) => `${BASE_URL}/${trimmedSku}/iframe.html`;

  const elementNeedsCheck = (el) => el.dataset.product360Checked !== 'true';

  const isElementWithSrc = (el) => el.tagName === 'IFRAME' || el.tagName === 'IMG' || el.hasAttribute('data-src-target');

  const setElementSrc = (el, url) => {
    if (el.tagName === 'IFRAME' || el.tagName === 'IMG') {
      el.src = url;
    } else if (el.hasAttribute('data-src-target')) {
      const targetSelector = el.getAttribute('data-src-target');
      const target = el.querySelector(targetSelector);
      if (target) target.src = url;
    }
  };

  const checkUrlAvailable = async (url) => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok;
    } catch {
      return false;
    }
  };

  const processElements = async () => {
    const allElements = Array.from(document.querySelectorAll(PRODUCT_SELECTOR)).filter(elementNeedsCheck);

    const groups = allElements.reduce((acc, el) => {
      const rawSku = el.dataset.productSku;
      if (!rawSku) {
        el.dataset.product360Checked = 'true';
        el.dataset.product360View = 'false';
        el.style.display = 'none';

        return acc;
      }

      const trimmedSku = getTrimmedSku(rawSku);
      acc[trimmedSku] = acc[trimmedSku] || [];
      acc[trimmedSku].push(el);
      return acc;
    }, {});

    await Promise.all(
      Object.entries(groups).map(async ([trimmedSku, elements]) => {
        const url = build360Url(trimmedSku);
        const isAvailable = await checkUrlAvailable(url);

        elements.forEach((el) => {
          el.dataset.product360Checked = 'true';
          el.dataset.product360View = isAvailable ? 'true' : 'false';

          if (!isAvailable) {
            el.style.display = 'none';
          } else if (isElementWithSrc(el)) {
            setElementSrc(el, url);
          }
        });
      })
    );
  };

  addGlobalEventListeners(processElements);
})();
